import { Injectable } from '@angular/core';

import { EnableClassTelemetry } from 'app/services/otel.service';
import { StorageAPIService } from '../storage-api.service';

@EnableClassTelemetry()
@Injectable()
export class StorageConfigurationService extends StorageAPIService {
  isRouteOrConfigurationInUse(id): Promise<{ configId: string; beingUsed: boolean }> {
    return this.get<{ configId; beingUsed }>(`/config/${id}/_check_in_use`);
  }
}
